import { Col, Layout, Row } from 'antd';
import { AppCopyright, AppLogo } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import AppNavigation from './AppNavigation';

export default function AppSider({ menuId }) {
  return (
    <Layout.Sider theme="light" width={224} style={{ boxShadow: '-1px 0 0 0 #e1e3e6 inset' }}>
      <Row style={{ flexFlow: 'column nowrap', height: '100%' }}>
        <Col flex="80px" style={{ display: 'flex', alignItems: 'center', padding: '0 24px' }}>
          <Link to="/desktops">
            <AppLogo />
          </Link>
        </Col>
        <Col flex={1}>
          <AppNavigation menuId={menuId} />
        </Col>
        <Col flex="none" style={{ textAlign: 'center', paddingBottom: 24 }}>
          <AppCopyright />
        </Col>
      </Row>
    </Layout.Sider>
  );
}
